import { AboutType } from './report-issue-handler.model';

export const getShortAboutType = (type: AboutType): string => {
  const mapping: Record<AboutType, string> = {
    [AboutType.FINAL_IMPRESSIONS]: '[Final imp]',
    [AboutType.GENERAL_SYSTEM_USABILITY]: '[Usability]',
    [AboutType.KEY_IMAGES]: '[KI]',
    [AboutType.ORGANS]: '[Organ]',
    [AboutType.OTHER]: '[Other]',
    [AboutType.PATIENT_HISTORY]: '[Hx, P, Reason]',
    [AboutType.REPORT_PREVIEW]: '[Report prev]',
    [AboutType.SECURITY]: '[Security]',
  };

  return mapping[type] || type;
};
